function Logger(args, ...rest) {
  if (__DEV__) {
    console.log(args, ...rest);
  }
}

export default Logger;
